/* eslint-disable no-param-reassign */

// Inspired by:
// https://github.com/orbiting/cms-draft/blob/fc6d509b61eb7fd0ad9429fae5e06fd11929c5f5/src/utils/markdown.js


const TOKENS = {
  IMAGE: 'image',
  IMAGE_OPEN: 'image_open',
  IMAGE_CLOSE: 'image_close'
};
const ImageRegexp = /^!\[([^\]]*)]\s*\(([^)"]+)( "([^)"]+)")?\)/


/**
 * Remarkable block parser for images
 * ![alt](url "title")
 */

export const parser = (state, startLine, endLine, silent) => {
  // position of line start in src + number of spaces used to indent it
  const pos = state.bMarks[startLine] + state.tShift[startLine]
  // position of line end in src
  const max = state.eMarks[startLine]

  if (pos >= max) return false
  if (!state.src) return false
  if (state.src[pos] !== '!') return false

  // check if is valid image element and get attributes
  const match = ImageRegexp.exec(state.src.slice(pos))
  if (!match) {
    return false
  }

  const [, alt, src, , title] = match

  // in silent mode it shouldn't output any tokens or modify pending
  if (!silent) {
    state.tokens.push({
      type: TOKENS.IMAGE_OPEN,
      src,
      alt,
      title: title || '',
      lines: [startLine, state.line],
      level: state.level
    })

    state.tokens.push({
      type: TOKENS.IMAGE_CLOSE,
      level: state.level
    })
  }

  state.line = startLine + 1

  return true
}

/**
 * Remarkable open renderer.
 * Doesnt really matter in this context
 */
export function openRenderer() {
  return () => '<div>'
}

/**
 * Callout closing tag renderer
 * Doesnt really matter in this context
 */
export function closeRenderer() {
  return () => '</div>';
}

const imageBlock = (md, opts) => {
  md.block.ruler.before('paragraph', TOKENS.IMAGE, parser, opts)
  md.renderer.rules[TOKENS.IMAGE_OPEN] = openRenderer(opts);
  md.renderer.rules[TOKENS.IMAGE_CLOSE] = closeRenderer(opts);
}

export default imageBlock
